import type { WishlistCreateItemPriority, WishlistCreateOccasion } from '@nexus/customer/wishlists/model';

export const WISHLIST_CREATE_OCCASION_LABELS: Readonly<Record<WishlistCreateOccasion, string>> = {
  birthday: 'Urodziny',
  holidays: 'Święta',
  layette: 'Wyprawka',
  sport: 'Sport',
  home: 'Dom',
  none: 'Bez okazji',
  custom: 'Własna',
};

export const WISHLIST_CREATE_PRIORITY_LABELS: Readonly<Record<WishlistCreateItemPriority, string>> = {
  low: 'Niski',
  medium: 'Średni',
  high: 'Wysoki',
};
